import React from 'react';
import classNames from 'classnames';
import './Footer.css';

interface Props {
  className?: string;
}

class Footer extends React.Component<Props> {

  render(): JSX.Element {
    const { className } = this.props;
    const fullClass: {[key: string]: boolean} = {
      footer: true,
      contacts: true,
    }
    if (className) fullClass[className] = true;
    return (
      <div className={classNames(fullClass)}>
        <span>По всем вопросам пишите на </span>
        <a className="mailto" href="mailto:hr@uchi.ru?subject=Referal program careers.uchi.ru">hr@uchi.ru</a>
        {/* Commented out due to new legislation (March 2022) */}
        {/*<a href="https://www.facebook.com/uchi.ru.team" target="_blank" rel="noopener noreferrer" className="social fb">fb</a>*/}
        {/*<a href="https://www.instagram.com/uchi.ru_team" target="_blank" rel="noopener noreferrer" className="social insta">in</a>*/}
      </div>
    );
  }
}

export default Footer;
